import { ChangeEvent } from 'react';

export const normalizeInputValueOnType = (e: ChangeEvent<HTMLInputElement>): number | null | undefined => {
  if (!e.target.value) {
    return undefined;
  }

  const numericValue = +e.target.value;

  if (Number.isNaN(numericValue)) {
    return null;
  }
  return numericValue;
};

export const normalizeInputValueOnBlur = (
  value: number | undefined,
  min: number,
  max: number,
  initialValue: number | undefined
): number | undefined => {
  if (value == null) {
    return undefined;
  }
  if (value < min) {
    return initialValue;
  }
  if (value > max) {
    return initialValue;
  }
  return Math.round(value);
};
